import { Tag } from '@shared/api/types';
import { Badge } from '@shared/components/ui/badge';
import { cn } from '@shared/lib/utils';
import { ClassValue } from 'clsx';

interface TagCellProps {
  className?: ClassValue;
  tags?: Tag[];
}

export function TagCell({ className, tags }: TagCellProps) {
  return (
    <div className={cn('flex flex-wrap gap-1', className)}>
      {tags?.map((tag) => (
        <Badge key={tag.uuid} variant="outline" size="sm">
          {tag.name}
        </Badge>
      ))}
    </div>
  );
}
